import styled from 'styled-components';

import {
  SubscriptionStatus,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

export const Container = styled(Flex).attrs({
  width: '100%',
  align: 'baseline',
  justify: 'space-between',
})`
  border-bottom: 1px solid #ccc;
  padding: 30px 15px;
`;

type StatusProps = {
  status: SubscriptionStatus
};

export const Status = styled.div<StatusProps>`
  position: relative;
  padding: 5px 15px;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
  border-radius: 7px;
  border: 1px solid  transparent;
  position: relative;
  top: 2px;

  ${(props) => {
    switch (props.status) {
      case 'active':
        return `
          color: ${props.theme.colors.success};
          border-color: ${props.theme.colors.success};
        `;
      case 'trialing':
        return `
          color: ${props.theme.colors.link};
          border-color: ${props.theme.colors.link};
        `;
      case 'past_due':
        return `
          color: #f0ad4e;
          border-color: #f0ad4e;
        `;
      case 'canceled':
        return `
          color: #343a3d;
          background: #efefef;
        `;
      default:
        return '';
    }
  }}
`;

export const CancelSubscriptionButton = styled(Text).attrs({
  as: 'button',
})`
  color: ${props => props.theme.colors.danger};
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
  position: relative;
  top: 2px;
  &:hover {
    color: #23527C;
  }
`;
